import { memo, useRef } from "react"
import { useWorkerContext } from "./hooks"

const InternalMemoizedWorker = memo((props: { worker: AIWorker, lastUpdate: number, children: React.ReactNode }) => <>{props.children}</>, (p, n) => p.lastUpdate === n.lastUpdate)

export function MemoizedWorker({ worker, children, name }: { worker?: AIWorker, children: React.ReactNode, name?: string }) {
  const ct = useWorkerContext()
  worker = worker || ct?.worker
  const lastUpdate = useRef(worker.lastUpdate)


  if (lastUpdate.current !== worker.lastUpdate) {
    lastUpdate.current = worker.lastUpdate
    // console.log(`MemoizedWorker '${name || "unknown"}' Updated`, lastUpdate.current, worker.lastUpdate)
  }
  return <InternalMemoizedWorker worker={worker} lastUpdate={lastUpdate.current}>{children}</InternalMemoizedWorker>
}
